import React from 'react';

export default function HeartIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable-next-line max-len
        d="M8 5.125L6.9375 4.0625L6.15625 3.3125C5.65625 2.8125 4.96875 2.5 4.21875 2.5C2.71875 2.5 1.5 3.75 1.5 5.25C1.5 6 1.78125 6.6875 2.28125 7.1875L3.03125 7.96875L8 12.9062L12.9375 7.96875L13.6875 7.1875C14.1875 6.6875 14.5 6 14.5 5.25C14.5 3.75 13.25 2.5 11.75 2.5C11 2.5 10.3125 2.8125 9.8125 3.3125L9.03125 4.0625L8 5.125ZM9.03125 13.9688L8 15L6.9375 13.9688L2 9L1.21875 8.25C0.4375 7.46875 0 6.375 0 5.25C0 2.90625 1.875 1 4.21875 1C5.34375 1 6.4375 1.46875 7.21875 2.25L8 3L8.75 2.25C9.53125 1.46875 10.625 1.03125 11.75 1.03125C14.0938 1 16 2.90625 16 5.25C16 6.375 15.5312 7.46875 14.75 8.25L14 9L9.03125 13.9688Z"
        fill="currentColor"
      />
    </svg>
  );
}
